/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkJobRequestCandidateStageMap } from './linkJobRequestCandidateStageMap';

export interface LinkJobRequest {
  connection_id: string;
  remote_job_id: string;
  candidate_stage_map?: LinkJobRequestCandidateStageMap;
  dry_run?: boolean;
  stage_shape_acknowledged?: boolean;
}
